import React, { Component } from 'react';
import { withRouter } from 'react-router';
// import dashboardActive from './../../../../Assets/mobile-footer/dashboard-icon.png' 
// import profileActive from './../../../../Assets/mobile-footer/profile-icon.png' 
// import uploadActive from './../../../../Assets/mobile-footer/upload-icon.png' 
// import settingActive from './../../../../Assets/mobile-footer/setting-icon.png' 
// import supportActive from './../../../../Assets/mobile-footer/support-icon.png' 
// import chatActive from './../../../../Assets/mobile-footer/chat-icon.png' 
// import postActive from './../../../../Assets/mobile-footer/post-icon.png' 
// import alertActive from './../../../../Assets/mobile-footer/alert-icon.png' 
import { connect } from 'react-redux'

import dashboardIcon from '../../../../Assets/images/mobile-icons/dashboard.png';
import dashboardGreen from '../../../../Assets/images/mobile-icons/dashboard-active.png';
import profileIcon from '../../../../Assets/images/mobile-icons/profile.png';
import profileGreen from '../../../../Assets/images/mobile-icons/profile-active.png';
import uploadIcon from '../../../../Assets/images/mobile-icons/upload.png';
import uploadGreen from '../../../../Assets/images/mobile-icons/upload-active.png';
import settingIcon from '../../../../Assets/images/mobile-icons/setting.png';
import settingGreen from '../../../../Assets/images/mobile-icons/setting-active.png';
import supportIcon from '../../../../Assets/images/mobile-icons/support.png';
import supportGreen from '../../../../Assets/images/mobile-icons/support-active.png';
import chatIcon from '../../../../Assets/images/mobile-icons/chat.png';
import chatGreen from '../../../../Assets/images/mobile-icons/chat-active.png';
import postIcon from '../../../../Assets/images/mobile-icons/post.png';
import postGreen from '../../../../Assets/images/mobile-icons/post-active.png';

class MobileFooter extends Component {

  state={
    selectedOption: 'dashboard'
  }

  routeObject = {
    // 'dashboard': '/',
    'dashboard': '/dashboard',
    'profile': '/CreatorProfile',
    'uploadProject': '/uploadproject/choose_collateral',
    'postProject': '/hire',
    'setting': '/Profile',
    'support': '/',
    'chat': '/chat', 
  }

  handleSelect = (option) => {
    this.setState({selectedOption: option});
    // console.log('%c Option', 'font-size: 22px; color:orange');
    // console.log(option);
    this.props.history.push(this.routeObject[option])
  }

  getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }

  componentDidMount(){
    // viewAll screens
    if(this.props.location.pathname.includes('viewAll')){
      this.setState({selectedOption: 'dashboard'})
      return;
    }
    
    const selectedOption =  this.getKeyByValue(this.routeObject, this.props.location.pathname)
    this.setState({selectedOption: selectedOption})
    // console.log(this.props)
  }

  render(){
    const { selectedOption } = this.state;
    const { CurrentRole } = this.props;
    // console.log('%c Current Role', 'font-size: 22px; color:orange');
    // console.log(CurrentRole);
    
    return (
      <div className="mobile-footer-fixed">
        {CurrentRole === 2 ? 
        <ul>
          <li onClick={this.handleSelect.bind(this, 'dashboard' )}>
            <a href="/" onClick={e=>e.preventDefault()} className={`${selectedOption === 'dashboard' ? 'active' : '' }`}>
              <span className="d-block text-center">
                {/* <i className={`fas fa-align-left mr-1 footer_icon footer-icon-border ${selectedOption === 'dashboard' ? 'active' : ''} `}></i> */}
                <img src={`${selectedOption === 'dashboard' ? dashboardGreen : dashboardIcon }`} alt="Dashboard" width="25" className={`footer_icons ${selectedOption === 'dashboard' ? 'active' : ''}`} />
              </span>Dashboard
                </a>
          </li>
          <li onClick={this.handleSelect.bind(this, 'profile' )}>
            <a href="/" onClick={e=>e.preventDefault()} className={`${selectedOption === 'profile' ? 'active' : '' }`}>
              <span className="d-block text-center">
                {/* <i className={`fas fa-user mr-1 footer_icon footer-icon-border ${selectedOption === 'profile' ? 'active' : ''} `}></i> */}
                {/* <img src={profileActive} alt="Profile" width="25" className={`footer_icons ${selectedOption === 'profile' ? 'active' : ''}`} /> */}
                <img src={`${selectedOption === 'profile' ? profileGreen : profileIcon }`} alt="Profile" width="25" className={`footer_icons ${selectedOption === 'profile' ? 'active' : ''}`} />
              </span> Profile
                </a>
          </li>
          <li onClick={this.handleSelect.bind(this, 'uploadProject' )}>
            <a href="/" onClick={e=>e.preventDefault()} className={`${selectedOption === 'uploadProject' ? 'active' : '' }`}>
              <span className="d-block text-center upload-btn-minus" data-toggle="modal" data-target="#project-select">
                {/* <i className={`fas fa-plus mr-1 footer_icon footer-icon-border mobile-upload ${selectedOption === 'upload' ? '' : ''}`}></i> */}
                {/* <img src={uploadActive} alt="uploadProject" width="45" className={`footer_icons ${selectedOption === 'uploadProject' ? 'active' : ''}`} /> */}
                <img src={`${selectedOption === 'upload' ? uploadGreen : uploadIcon }`} alt="uploadProject" width="25" className={`footer_icons ${selectedOption === 'uploadProject' ? 'active' : ''}`} />
              </span> Upload
                </a>
          </li>
          <li onClick={this.handleSelect.bind(this, 'setting')}>
            <a href="/" onClick={e=>e.preventDefault()} className={`${selectedOption === 'setting' ? 'active' : '' }`}>
              <span className="d-block text-center">
                {/* <i className={`fas fa-cog mr-1 footer_icon extra-size ${selectedOption === 'setting' ? 'active' : ''}`}></i> */}
                {/* <img src={settingActive} alt="setting" width="25" className={`footer_icons ${selectedOption === 'setting' ? 'active' : ''}`} /> */}
                <img src={`${selectedOption === 'setting' ? settingGreen : settingIcon }`} alt="setting" width="25" className={`footer_icons ${selectedOption === 'setting' ? 'active' : ''}`} />
              </span> Settings
                </a>
          </li>
          <li onClick={this.handleSelect.bind(this, 'support')}>
            <a href="/contactus" target="_blank" className={`${selectedOption === 'support' ? 'active' : '' }`}>
              <span className="d-block text-center">
                {/* <i className={`fas fa-comment mr-1 footer_icon extra-size ${selectedOption === 'support' ? 'active' : ''}`}></i> */}
                {/* <img src={supportActive} alt="support" width="26" className={`footer_icons ${selectedOption === 'support' ? 'active' : ''}`} /> */}
                <img src={`${selectedOption === 'support' ? supportGreen : supportIcon }`} alt="support" width="26" className={`footer_icons ${selectedOption === 'support' ? 'active' : ''}`} />
              </span> Support
                  </a>
          </li>
        </ul> : 
        <ul>
          <li onClick={this.handleSelect.bind(this, 'dashboard' )}>
            <a href="/" onClick={e=>e.preventDefault()} className={`${selectedOption === 'dashboard' ? 'active' : '' }`}>
              <span className="d-block text-center">
                {/* <i className={`fas fa-align-left mr-1 footer_icon footer-icon-border ${selectedOption === 'dashboard' ? 'active' : ''} `}></i> */}
                {/* <img src={dashboardActive} alt="Dashboard" width="25" className={`footer_icons ${selectedOption === 'dashboard' ? 'active' : ''}`} /> */}
                <img src={`${selectedOption === 'dashboard' ? dashboardGreen : dashboardIcon }`} alt="Dashboard" width="25" className={`footer_icons ${selectedOption === 'dashboard' ? 'active' : ''}`} />
              </span>Dashboard
                </a>
          </li>
          <li onClick={this.handleSelect.bind(this, 'chat' )}>
            <a href="/" onClick={e=>e.preventDefault()} className={`${selectedOption === 'chat' ? 'active' : '' }`}>
              <span className="d-block text-center">
                {/* <i className={`fas fa-user mr-1 footer_icon footer-icon-border ${selectedOption === 'chat' ? 'active' : ''} `}></i> */}
                {/* <img src={chatActive} alt="chat" width="26" className={`footer_icons ${selectedOption === 'chat' ? 'active' : ''}`} /> */}
                <img src={`${selectedOption === 'chat' ? chatGreen : chatIcon }`} alt="chat" width="25" className={`footer_icons ${selectedOption === 'chat' ? 'active' : ''}`} />
              </span> Chat
                </a>
          </li>
          <li onClick={this.handleSelect.bind(this, 'postProject' )}>
            <a href="/" onClick={e=>e.preventDefault()} className={`${selectedOption === 'postProject' ? 'active' : '' }`}>
              <span className="d-block text-center upload-btn-minus" data-toggle="modal" data-target="#project-select">
                {/* <i className={`fas fa-plus mr-1 footer_icon footer-icon-border mobile-upload ${selectedOption === 'postProject' ? '' : ''}`}></i> */}
                {/* <img src={postActive} alt="post-project" width="45" className={`footer_icons ${selectedOption === 'postProject' ? 'active' : ''}`} /> */}
                <img src={`${selectedOption === 'postProject' ? postGreen : postIcon }`} alt="post-project" width="25" className={`footer_icons ${selectedOption === 'postProject' ? 'active' : ''}`} />
              </span> {this.props.CurrentRole===1?'Hire' : 'Post Project'}
                </a>
          </li>
          {/* <li onClick={this.handleSelect.bind(this, 'alert')}>
            <a  className={`${selectedOption === 'alert' ? 'active' : '' }`}>
              <span className="d-block text-center">
                <i className={`fas fa-comment mr-1 footer_icon extra-size ${selectedOption === 'alert' ? 'active' : ''}`}></i>
                <img src={alertActive} alt="alert" width="26" className={`footer_icons ${selectedOption === 'alert' ? 'active' : ''}`} />
              </span> Alert
                  </a>
          </li> */}
          <li onClick={this.handleSelect.bind(this, 'setting')}>
            <a href="/" onClick={e=>e.preventDefault()} className={`${selectedOption === 'setting' ? 'active' : '' }`}>
              <span className="d-block text-center">
                {/* <i className={`fas fa-cog mr-1 footer_icon extra-size ${selectedOption === 'setting' ? 'active' : ''}`}></i> */}
                {/* <img src={settingActive} alt="setting" width="28" className={`footer_icons ${selectedOption === 'setting' ? 'active' : ''}`} /> */}
                <img src={`${selectedOption === 'setting' ? settingGreen : settingIcon }`} alt="setting" width="25" className={`footer_icons ${selectedOption === 'setting' ? 'active' : ''}`} />
              </span> Settings
                </a>
          </li>
          <li onClick={this.handleSelect.bind(this, 'support')}>
            <a href="/contactus" target="_blank" className={`${selectedOption === 'support' ? 'active' : '' }`}>
              <span className="d-block text-center">
                {/* <i className={`fas fa-comment mr-1 footer_icon extra-size ${selectedOption === 'support' ? 'active' : ''}`}></i> */}
                {/* <img src={supportActive} alt="support" width="26" className={`footer_icons ${selectedOption === 'support' ? 'active' : ''}`} /> */}
                <img src={`${selectedOption === 'support' ? supportGreen : supportIcon }`} alt="support" width="26" className={`footer_icons ${selectedOption === 'support' ? 'active' : ''}`} />
              </span> Support
                  </a>
          </li>
          
        </ul>
        }
      </div>
    )
  }
}


const mapState = (store) => {
  const globalReducer = store.globalReducer;
  return {
    CurrentRole: globalReducer.Me.CurrentRole
  }
}


export default withRouter(connect(mapState)(MobileFooter))